import "@babel/polyfill";

import "./polyfill";

import "core-js/es6";

import VueCompositionAPI from '@vue/composition-api'

Vue.use(VueCompositionAPI)

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import vuetify from './plugins/vuetify'

import VueResource from 'vue-resource'
import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.min.css'

import _ from 'lodash'

import i18n from './i18n'

import VueCookie from 'vue-cookie'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import VueQrcode from '@chenfengyuan/vue-qrcode';
import VueYouTubeEmbed from 'vue-youtube-embed'
import VueFriendlyIframe from 'vue-friendly-iframe';

Vue.use(VueYouTubeEmbed)
Vue.use(VueFriendlyIframe);


Vue.component(VueQrcode.name, VueQrcode);

import vueHeadful from 'vue-headful';

Vue.component('vue-headful', vueHeadful);

import VueClipboard from 'vue-clipboard2'

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

import VueMask from 'v-mask'

Vue.use(VueMask)

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import sanitizeHtml from "sanitize-html";
import {DateTime} from 'luxon';

Vue.use(BootstrapVue);
Vue.use(VueResource);

Vue.use(Datetime);
Vue.use(VueCookie);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.component(VueQrcode.name, VueQrcode);

//V-Viewer
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

Vue.use(Viewer);

// locale
import 'tinymce-i18n/langs5/zh_TW.js'

// vuetify-dialog
import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'
import BannerDialog from "@/components/BannerDialog";
import {CYBER_SOURCE_PAYMENT_DECISION, DISCOUNT_CODE_TYPE, PAYMENT_METHOD} from "@/constants";
import cronstrue from 'cronstrue/i18n';

Vue.use(VuetifyDialog, {
  context: {
    i18n,
    vuetify,
    store,
  }
});

Vue.config.productionTip = false;

Vue.config.ignoredElements = ['g:savetoandroidpay'];

// export const HOST = 'https://hkiarace-uat.teamnoteapp.com/api/';
export const HOST = '/api/';

if (!String.prototype.padStart) {
  String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
    padString = String((typeof padString !== 'undefined' ? padString : ' '));
    if (this.length > targetLength) {
      return String(this);
    } else {
      targetLength = targetLength - this.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
      }
      return padString.slice(0, targetLength) + String(this);
    }
  };
}

if (!String.prototype.repeat) {
  String.prototype.repeat = function (count) {
    'use strict';
    if (this == null) {
      throw new TypeError('can\'t convert ' + this + ' to object');
    }
    var str = '' + this;
    count = +count;
    if (count != count) {
      count = 0;
    }
    if (count < 0) {
      throw new RangeError('repeat count must be non-negative');
    }
    if (count == Infinity) {
      throw new RangeError('repeat count must be less than infinity');
    }
    count = Math.floor(count);
    if (str.length == 0 || count == 0) {
      return '';
    }
    // Ensuring count is a 31-bit integer allows us to heavily optimize the
    // main part. But anyway, most current (August 2014) browsers can't handle
    // strings 1 << 28 chars or longer, so:
    if (str.length * count >= 1 << 28) {
      throw new RangeError('repeat count must not overflow maximum string size');
    }
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while (count) {
      str += str;
      count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
  }
}


Vue.use({
  install() {
    // Loading Spinner
    Vue.prototype.$startLoading = function (timeout) {
      this.$store.commit('startLoading', timeout);
    };
    Vue.prototype.$stopLoading = function () {
      this.$store.commit('stopLoading');
    };
    // Alert Top Bar
    Vue.prototype.$showAlertMessage = function (message, handler, actions = null) {
      this.$eventHub.$emit('showAlertMessage', {message, handler, actions});
    };

    // API Call
    Vue.prototype.$callAPI = function (url, params, success, failure, not_blocking, extra) {
      if (!not_blocking) {
        this.$startLoading();
      }
      var v = this;
      Vue.http.post(HOST + url, params, extra).then(function (response) {
        if (!not_blocking) {
          v.$stopLoading();
        }
        success.bind(v)(response);
      }, function (response) {
        if (!not_blocking) {
          v.$stopLoading();
        }
        if (failure) {
          failure.bind(v)(response);
        } else {
          if (response.status === 401 || response.status === 302) {
            v.$storeDispatch('logout');
            // v.$router.push({name: 'login'});

            v.$eventHub.$emit('logout');
            return;
          } else if (typeof response.body === 'object') {
            if ('msg' in response.body) {
              let msg = response.body.msg;

              if (v.$te('error_messages.' + msg)) {
                v.$showAlertMessage(v.$t('error_messages.' + msg));
                return
              } else {
                v.$showAlertMessage(msg);
                return
              }
            }
          }
          v.$showAlertMessage(v.$t('error_messages.default'));
        }
      });
    };

    Vue.prototype.$downloadFile = function (url, params, filename, mime_type, failure) {
      this.$startLoading();
      var v = this;
      Vue.http.post(HOST + url, params, {responseType: 'arraybuffer'}).then(function (response) {
        v.$stopLoading();

        let blob = new Blob([response.data], {type: mime_type});

        if (navigator.appVersion.toString().indexOf('.NET') > 0) {
          window.navigator.msSaveBlob(blob, filename);
        } else {
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }, function (response) {
        v.$stopLoading();
        if (failure) {
          failure.bind(v)(response);
        } else {
          if (response.status === 401 || response.status === 302) {
            v.$storeDispatch('logout');
            v.$router.push({name: 'login'});
          } else if (typeof response.body === 'object') {
            if ('msg' in response.body) {
              v.$showAlertMessage(response.body.msg);
            } else {
              v.$showAlertMessage();
            }
          } else {
            v.$showAlertMessage();
          }
        }
      });
    };

    Vue.prototype.$uploadFiles = function (files, success, failure) {
      let formData = new FormData();

      let needUpload = false;
      files.forEach(function (f) {
        if (f instanceof File || f instanceof Blob) {
          needUpload = true;
          formData.append('file', f, f.name);
        }
      });

      if (needUpload) {
        this.$callAPI('upload/', formData, success, failure);
      } else {
        success.bind(this)();
      }
    };

    // Vuex
    Vue.prototype.$storeDispatch = function (name, payload) {
      this.$store.dispatch(name, {v: this, ...payload});
    };

    //URL Param
    Vue.prototype.$getUrlParam = function (name) {
      let results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.href);
      if (results == null) {
        return null;
      } else {
        return decodeURI(results[1]) || 0;
      }
    };

    //Event Bus
    Vue.prototype.$eventHub = new Vue();

    //Resolve dot notation
    Vue.prototype.$resolve = function (obj, path) {
      return _.reduce(path.split('.'), function (o, k) {
        if (o === null) {
          return o;
        } else {
          return o[k] || null;
        }
      }, obj);
    };

    //Get attribute based on locale
    Vue.prototype.$localeGet = function (obj, attr) {
      return obj[attr + "_" + this.$i18n.locale] || obj[attr];
    };

    // Update Route
    Vue.prototype.$updateRoute = function (paramOverride, queryOverride) {
      this.$router.replace({
        name: this.$route.name,
        params: {
          ...this.$route.params,
          ...paramOverride,
        },
        query: {
          ...this.$route.query,
          ...queryOverride,
        },
      })
    };

    //Permission Checking
    Vue.prototype.$hasModulePermission = function (module_key) {
      return this.$store.getters.hasModulePermission(module_key);
    };
    Vue.prototype.$hasPermission = function (key) {
      return this.$store.getters.hasPermission(key);
    };

    Vue.prototype.$sanitizeHtml = function (str) {
      return sanitizeHtml(str, {
        allowedTags: [],
      });
    };

    //
    Vue.prototype.$convertFileToBase64 = async function (file) {
      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });

      return await toBase64(file);
    };

    Vue.prototype.$parseDate = function (d, fmt = 'yyyy-MM-dd HH:mm') {
      return DateTime.fromISO(d).toFormat(fmt);
    };
    Vue.prototype.$parseCronString = function (cronString, until = null) {
      if (!cronString) return '';

      const locale = {
        'en': 'en',
        'zh': 'zh_TW',
      }[this.$i18n.locale];

      return cronstrue.toString(cronString.replace('m', '0').replace('h', '0'), {verbose: true, locale}).substr('At 12:00 AM, '.length).replace('only ', '') +
        (until ? `, Until ${DateTime.fromISO(until).toFormat('yyyy-MM-dd')}` : '');
    }

    Vue.prototype.$showBanners = async function (banners) {
      for (let i = 0; i < banners.length; i++) {
        await this.$dialog.showAndWait(BannerDialog, {
          banner: banners[i],
          showClose: false,
          fullscreen: true,
          transition: false,
        });
      }
    };

    Vue.prototype.$getDiscountCodeDescription = function (discountCode) {
      const discount = discountCode.discount_value ? this.$t('discount_code_descriptions.discount_value', {discount: discountCode.discount_value}) : this.$t('discount_code_descriptions.discount_percentage', {discount: discountCode.discount_percentage});
      const minimum_amount = discountCode.minimum_amount > 0 ? this.$t('discount_code_descriptions.minimum_amount', {amount: discountCode.minimum_amount}) : '';
      const use_per_account = discountCode.use_per_account > 0 ? this.$t('discount_code_descriptions.use_per_account', {count: discountCode.use_per_account}) : '';
      if (discountCode.type === DISCOUNT_CODE_TYPE.FACILITY) {
        return this.$t('discount_code_descriptions.FACILITY', {
          item_type: discountCode.item_type.name,
          minimum_amount,
          discount,
          use_per_account,
        })
      } else if (discountCode.type === DISCOUNT_CODE_TYPE.GYM_PASS) {
        return this.$t('discount_code_descriptions.GYM_PASS', {
          gym_pass_type: discountCode.gym_pass_type.name,
          minimum_amount,
          discount,
          use_per_account,
        })
      } else if (discountCode.type === DISCOUNT_CODE_TYPE.MEMBERSHIP) {
        return this.$t('discount_code_descriptions.MEMBERSHIP', {
          minimum_amount,
          discount,
          use_per_account,
        })
      }
    };

    //
    Vue.prototype.$getPaymentRecordRefNo = function (paymentRecord) {
      if (paymentRecord) {
        if (paymentRecord.payment_method === 'cyber_source') {
          const first = _.first(paymentRecord.cyber_source_payment_records);
          if (first) {
            return first.request_ref_no;
          }
        }
      }
    };
    Vue.prototype.$getPaymentRecordStatus = function (paymentRecord) {
      if (paymentRecord) {
        if (paymentRecord.payment_method === PAYMENT_METHOD.CYBER_SOURCE) {
          const lastRecord = _.last(_.orderBy(paymentRecord.cyber_source_payment_records, 'update_at'));
          if (lastRecord) {
            if (lastRecord.decision) {
              return this.$t(`cyber_source_payment_decision.${lastRecord.decision}`);
            } else {
              return this.$t(`cyber_source_payment_decision.PENDING`);
            }
          }
        }
      }
    };
    Vue.prototype.$getPaymentRecordCardNo = function (paymentRecord) {
      let card_no = 0;

      if (paymentRecord) {
        if (paymentRecord.payment_method === PAYMENT_METHOD.CYBER_SOURCE) {
          _.forEach(paymentRecord.cyber_source_payment_records, (r) => {
            if (r.card_number) {
              card_no = r.card_number;
            }
          })
        }
      }

      return card_no;
    };
    Vue.prototype.$getPaymentRecordTotal = function (paymentRecord) {
      let amount = 0;

      if (paymentRecord) {
        if (paymentRecord.payment_method === PAYMENT_METHOD.CYBER_SOURCE) {
          _.forEach(paymentRecord.cyber_source_payment_records, (r) => {
            if (r.decision !== CYBER_SOURCE_PAYMENT_DECISION.REFUND) {
              amount += r.amount;
            }
          })
        }
      }

      return amount;
    };
  },
});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app');
